import maintenance from "../../assets/maintenance.jpg";

export default function Maintenence() {
  return (
    <div className="maintenance-container">
      <img src={maintenance} alt="maintenance" />
      <h1>We'll Be Back Soon!</h1>
      <p>
        Our website is currently undergoing scheduled maintenance. We appreciate
        your patience and apologize for any inconvenience.
      </p>

      <p>Thank you for understanding!</p>
    </div>
  );
}
